import { FC, HTMLAttributes } from "react";
import { useStyles } from "./SubscriptionCard.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { Button } from "../../core/Button/Button";
import { TypographyVariant } from "../../../constants/typography";
import { useTranslation } from "react-i18next";

interface ISubscriptionCardProps {
  title: string;
  billingDate: string;
  logo?: string;
  onUnsubscribe?: () => void;
}

export const SubscriptionCard: FC<
  ISubscriptionCardProps & HTMLAttributes<HTMLDivElement>
> = ({ title, billingDate, logo, onUnsubscribe, ...props }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root} {...props}>
      {logo && <StaticImage src={logo} className={classes.logo} />}
      <div className={classes.header}>
        <Typography
          className={classes.title}
          variant={TypographyVariant.BodyB2Bold}
        >
          {title}
        </Typography>
        <div className={classes.body}>
          <div className={classes.billingInfo}>
            <Typography variant={TypographyVariant.BodyB6Regular}>
              {t("subscription_next_billing_date", {
                defaultValue: "Next billing date",
              })}:
            </Typography>
            <Typography variant={TypographyVariant.BodyB6Regular}>
              {billingDate}
            </Typography>
          </div>
          <Button
            variant="contained"
            size="small"
            onClick={onUnsubscribe}
            className={classes.unsubscribeButton}
          >
            {t("unsubscribe", { defaultValue: "Unsubscribe" })}
          </Button>
        </div>
      </div>
    </div>
  );
};
